module.exports = __webpack_public_path__ + "img/lazada.b9e1888e.png";